import { useEffect, useState } from 'react';
import { Box, TextField, Typography, Button } from "@mui/material";

import { useAuth } from '../contexts/AuthContext';
import { callApi } from '../utils/request';
import { useNavigate } from "react-router-dom";

import Logo from '../logo_bsl.png';

import Alert from './Alert';

// FormLogin est un composant de formulaire de connexion qui
// gère l'authentification des utilisateurs.
export default function FormLogin() {
    const [alert, setAlert] = useState(null);
    const [codeSend, setCodeSent] = useState(false);
    const [userInformations, setUserInformations] = useState({});

    const navigate = useNavigate();

    const { login, isAuthenticated, userRole } = useAuth();

    useEffect(() => {
        if (isAuthenticated) {
            if (userRole === 'admin') {
                navigate('/dashboard/');
            } else {
                navigate('/dashboard/ListSimulation');
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

    const handleChange = (event) => {
        setUserInformations({ ...userInformations, [event.target.name]: event.target.value });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!codeSend) {
            callApi('/auth/get-code', 'POST', userInformations).then((res) => {
                if (res.alert) {
                    setAlert(res.alert);
                    if (res.alert.variant === 'success') {
                        setCodeSent(true);
                    }
                }
            });
        } else {
            callApi('/auth/login', 'POST', userInformations).then((res) => {
                if (res.token) {
                    login(res.token);
                }
            });
        }
    };

    return (
    <>
        {alert && <Alert alert={alert}/>}
        <Box className="form">
            <img src={Logo} alt="logo" width="200px" />

            {/* Titre du formulaire de connexion */}
            <Typography
                variant="h1"
                sx={{
                    my:3,
                    fontSize: '1.5rem',
                    textAlign: 'center'
                }}
                children="Veuillez vous connecter pour accéder au simulateur BSL"
            />

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                {/* Champ de saisie pour l'email */}
                <TextField
                    required
                    margin="normal"
                    id="mail"
                    label="Adresse e-mail"
                    name="mail"
                    type="email"
                    placeholder="john.doe@bslportage.fr"
                    autoComplete="email"
                    autoFocus
                    fullWidth
                    onChange={handleChange}
                />

                {/* Champ de saisie pour le code OTP, affiché uniquement après l'envoi du code */}
                {codeSend &&
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="otpCode"
                        label="Code OTP"
                        type="text"
                        id="otpCode"
                        onChange={handleChange}
                    />
                }

                {/* Bouton de soumission du formulaire */}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 3 }}
                    children={codeSend ? 'Connexion' : 'Demander un code OTP'}
                />
            </Box>
        </Box>
    </>
    );
};